module.exports = __webpack_public_path__ + "img/icon_yd.030b1e9e.png";